<template>
    <v-card class="mt-3 mb-3">
        <v-layout row>
            <v-flex xs4>
                <v-img
                        src="http://img.aiata.cn/share/logo.jpg"
                        height="125px"
                        contain></v-img>
            </v-flex>
            <v-flex xs8>
                <v-card-title primary-title>
                    <div>
                        <div class="title pb-2">还没有关注公众号？</div>
                        <span>现在就关注，免费获得每日挑战提醒和更多福利。</span>
                    </div>
                </v-card-title>
            </v-flex>
        </v-layout>
        <v-divider light></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="showQr">关注</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    export default {
        data() {
            return {}
        },
        mounted() {

        },
        computed: {},
        methods: {
            showQr() {
                this.wx.previewImage({
                    current: 'http://img.aiata.cn/assets/qr.jpg', // 当前显示图片的http链接
                    urls: ['http://img.aiata.cn/assets/qr.jpg'] // 需要预览的图片http链接列表
                });
            }
        }
    }
</script>

<style lang="scss">

</style>
